import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { FetchError } from 'queries'
import { fetchWithAuth } from 'queries/fetch-with-auth'
import { postEuWithdrawalURL } from 'queries/routes'

export const POST_EU_WITHDRAWAL_ERROR = 'Failed to submit withdrawal'

export interface PostEuWithdrawalVariables {
  transactionId: string
  token: string | null
}

export async function postEuWithdrawal({ transactionId, token }: PostEuWithdrawalVariables): Promise<void> {
  const response = await fetchWithAuth(postEuWithdrawalURL(), token, {
    method: 'POST',
    body: JSON.stringify({ transaction_id: transactionId }),
  })

  if (!response.ok) {
    const { status, statusText } = response
    let cause: Error | undefined
    try {
      cause = (await response.json()) as Error
    } catch {
      cause = undefined
    }
    throw new FetchError(POST_EU_WITHDRAWAL_ERROR, { cause }, status, statusText)
  }
}

// No onError toast, unlike usePostPortalSession: failures render inside the modal.
export const usePostEuWithdrawal = (options?: UseMutationOptions<void, FetchError, PostEuWithdrawalVariables>) => {
  return useMutation<void, FetchError, PostEuWithdrawalVariables>(postEuWithdrawal, options)
}
